import React from "react";
import { useLocation } from "react-router-dom";
import RoutePage from "./app/RoutePage";
import { GlobalStyles } from "./modules/GlobalStyled/GlobalStyles";
import Header from "./modules/Header/Header.jsx";
import ImpersonationBanner from "./modules/Impersonation/ImpersonationBanner.jsx";
import Modals from "./modules/Modals/Modals.jsx";
import PopupProvider from "./modules/Popup/PopupProvider";
import LangProvider from "./providers/LangProvider/LangProvider.jsx";
import { RouterPaths } from "./app/appConstants";

function App() {
    const location = useLocation();
    const isLandingPage = location.pathname === RouterPaths.main;

    return <>
        <GlobalStyles/>
        <LangProvider>
            <PopupProvider>
                <ImpersonationBanner/>
                {!isLandingPage && <Header/>}
                <div style={isLandingPage ? undefined : { margin: '0 16px' }}>
                    <Modals/>
                    <RoutePage/>
                </div>
            </PopupProvider>
        </LangProvider>
    </>;
}

export default App;
